export const openIllustoEditor = ({ userId, entityId, redirectUrl, isNewProject = false, openInNew }) => {
  if (!redirectUrl) return;
  document.cookie = `magnifi-auth=${localStorage.getItem("authToken")}; domain=.magnifi.ai;path=/;`;
  document.cookie = `magnifi-user-id=${userId}; domain=.magnifi.ai;path=/;`;
  document.cookie = `entityId=${entityId}; domain=.magnifi.ai;path=/;`;

  const url = `${redirectUrl}&newProject=${isNewProject}`;

  if (openInNew) window.open(url, "_blank");
  else window.location.href = url;
};

export const aspectRatioCheckForIllusto = () => {
  // aspect ratio that studio don't support, will get added here
  return false;
};
